import { memo } from "react";

const Edit = ({ onClick, width="16", height="16" }: { onClick?: () => void, width?: string, height?: string }) => (
  <svg onClick={onClick} width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_282_5444)">
      <path d="M16 0H0V16H16V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M14 8.66667V13.3333C14 13.7015 13.7015 14 13.3333 14H2.66667C2.29848 14 2 13.7015 2 13.3333V2.66667C2 2.29848 2.29848 2 2.66667 2H7.33333"
        stroke="currentColor"
        strokeWidth="1.21905"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66687 8.90663V11.3333H7.10594L14.0002 4.43603L11.5652 2L4.66687 8.90663Z"
        stroke="currentColor"
        strokeWidth="1.21905"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_282_5444">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default memo(Edit);
